import { render, staticRenderFns } from "./MypageTicketTodayCurrentTimeParts.vue?vue&type=template&id=ed589b86&scoped=true"
import script from "./MypageTicketTodayCurrentTimeParts.vue?vue&type=script&lang=ts"
export * from "./MypageTicketTodayCurrentTimeParts.vue?vue&type=script&lang=ts"
import style0 from "./MypageTicketTodayCurrentTimeParts.vue?vue&type=style&index=0&id=ed589b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed589b86",
  null
  
)

export default component.exports